// Saga Request Actions
export const BOOKMARK_SECTION_NAME_UPDATE_REQUEST =
  "BOOKMARK_SECTION_NAME_UPDATE_REQUEST";
export const CREATE_BOOKMARK_SECTION_REQUEST =
  "CREATE_BOOKMARK_SECTION_REQUEST";
export const REMOVE_BOOKMARK_SECTION_REQUEST =
  "REMOVE_BOOKMARK_SECTION_REQUEST";
export const BOOKMARK_SECTION_SELECT_REQUEST =
  "BOOKMARK_SECTION_SELECT_REQUEST";
export const REMOVE_BOOKMARK_FROM_SECTION_REQUEST =
  "REMOVE_BOOKMARK_FROM_SECTION_REQUEST";
export const REMOVE_ALL_BOOKMARKS_IN_SECTION_REQUEST =
  "REMOVE_ALL_BOOKMARKS_IN_SECTION_REQUEST";
export const UPDATE_BOOKMARK_SECTION_NAME_REQUEST =
  "UPDATE_BOOKMARK_SECTION_NAME_REQUEST";

// Action / Reducer Identifiers
export const UPDATE_BOOKMARK_SECTION_NAME_INPUT =
  "UPDATE_BOOKMARK_SECTION_NAME_INPUT";
export const CREATE_BOOKMARK_SECTION = "CREATE_BOOKMARK_SECTION";
export const REMOVE_BOOKMARK_SECTION = "REMOVE_BOOKMARK_SECTION";
export const UPDATE_BOOKMARKS_SECTION_CONTENTS =
  "UPDATE_BOOKMARKS_SECTION_CONTENTS";
export const LOAD_BOOKMARK_SECTIONS_COMPLETE =
  "LOAD_BOOKMARK_SECTIONS_COMPLETE";
export const REMOVE_BOOKMARK_FROM_SECTION = "REMOVE_BOOKMARK_FROM_SECTION";
export const REMOVE_ALL_BOOKMARKS_FROM_SECTION =
  "REMOVE_ALL_BOOKMARKS_FROM_SECTION";
export const UPDATE_BOOKMARK_SECTION_NAME = "UPDATE_BOOKMARK_SECTION_NAME";
